import { ResourceElement } from "./ResourceElement";
import * as THREE from '@phdsoft/three';

export class MaterialSubType extends ResourceElement {
    private _density: number;
    public get density(): number {
        return this._density;
    }
    public set density(v: number) {
        this._density = v;
    }

    private _modulusOfElasticity: number;
    public get modulusOfElasticity(): number {
        return this._modulusOfElasticity;
    }
    public set modulusOfElasticity(v: number) {
        this._modulusOfElasticity = v;
    }

    private _shearModulus: number;
    public get shearModulus(): number {
        return this._shearModulus;
    }
    public set shearModulus(v: number) {
        this._shearModulus = v;
    }

    private _yieldStrength: number;
    public get yieldStrength(): number {
        return this._yieldStrength;
    }
    public set yieldStrength(v: number) {
        this._yieldStrength = v;
    }

    private _ultimateStrength: number;
    public get ultimateStrength(): number {
        return this._ultimateStrength;
    }
    public set ultimateStrength(v: number) {
        this._ultimateStrength = v;
    }

    private _breakingStrength: number;
    public get breakingStrength(): number {
        return this._breakingStrength;
    }
    public set breakingStrength(v: number) {
        this._breakingStrength = v;
    }

    private _poissonRatio: number;
    public get poissonRatio(): number {
        return this._poissonRatio;
    }
    public set poissonRatio(v: number) {
        this._poissonRatio = v;
    }

    private _grade: string;
    public get grade(): string {
        return this._grade;
    }
    public set grade(v: string) {
        this._grade = v;
    }

    private _youngModulus: number;
    public get youngModulus(): number {
        return this._youngModulus;
    }
    public set youngModulus(v: number) {
        this._youngModulus = v;
    }

    private _tensileStrength: number;
    public get tensileStrength(): number {
        return this._tensileStrength;
    }
    public set tensileStrength(v: number) {
        this.tensileStrength = v;
    }

    private _Color: string;
    public get Color(): string {
        return this._Color;
    }
    public set Color(v: string) {
        this._Color = v;
    }


    private _renderMaterial: THREE.Material;
    public get renderMaterial(): THREE.Material {
        return this._renderMaterial;
    }
    public set renderMaterial(v: THREE.Material) {
        this._renderMaterial = v;
    }


    constructor(material: any) {
        super();

        this._Color = material.Color;
        this._grade = material.Grade;
        this._density = material.Density;
        this._youngModulus = material.YoungModulus;
        this.shearModulus = material.ShearModulus;
        this._yieldStrength = material.YieldStrength;
        this._poissonRatio = material.PoissonRatio;
    }
}